import React from "react";
import { Card, CardBody } from "reactstrap";

import EmbedShell from "./EmbedShell";
import ClassroomTrialTable from "../ClassroomTrial/ClassroomTrialTable";

/**
 * LEZIONI GRATUITE in modalita' embed (dentro l'iframe di ATOM).
 *
 * La tabella non naviga da nessuna parte (i partecipanti si aprono in un modale, il
 * collegamento alla riunione va in una scheda nuova), ma per ADMIN e TEACHER mostra le
 * azioni che SCRIVONO: crea, modifica, elimina. La prop `embed` le spegne — dentro
 * l'iframe la pagina e' consultazione pura, come l'elenco classi.
 */
const EmbedLezioniGratuite = () => {
    document.title = "Lezioni Gratuite | CLTV";
    return (
        <EmbedShell titolo="Lezioni Gratuite">
            <Card><CardBody>
                <ClassroomTrialTable embed={true} />
            </CardBody></Card>
        </EmbedShell>
    );
};

export default EmbedLezioniGratuite;
